const HERO_IMAGE =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/NehruTrophyBoatRace2024.jpg/1280px-NehruTrophyBoatRace2024.jpg';

const GALLERY_IMAGES = {
  heats:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/NehruTrophyBoatRace2024.jpg/1280px-NehruTrophyBoatRace2024.jpg',
  alleppey:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Nehru_trophy_boat_race%2C_Alleppey_%289488357610%29.jpg/1280px-Nehru_trophy_boat_race%2C_Alleppey_%289488357610%29.jpg',
  aranmula:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Kerala_boatrace.jpg/1280px-Kerala_boatrace.jpg',
  boats:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Kerala_boatrace.jpg/1280px-Kerala_boatrace.jpg',
};

/** 72-ാം നെഹ്‌റു ട്രോഫി വള്ളംകളി — പൂർണ്ണ മലയാളം ഗൈഡ് (2026) */
export const NEHRU_TROPHY_MALAYALAM_POST = {
  id: 'featured-nehru-trophy-2026-malayalam',
  slug: 'nehru-trophy-2026-chundan-vallam-malayalam',
  title: '72-ാം നെഹ്‌റു ട്രോഫി വള്ളംകളി 2026: ചുണ്ടൻ വള്ളങ്ങൾ, ക്ലബുകൾ, കാപ്റ്റൻമാർ',
  excerpt:
    'ഓഗസ്റ്റ് 22ന് പുന്നമടയിൽ: 22 ചുണ്ടൻ വള്ളങ്ങളും ക്ലബുകളും, കാപ്റ്റൻ/ഹരിപ്പ് കാപ്റ്റൻ വിവരങ്ങൾ, ഫോട്ടോ ഗാലറി, മലയാളം വീഡിയോകൾ — പൂർണ്ണ മലയാളം ഗൈഡ്.',
  publishedAt: '2026-08-13T14:00:00.000Z',
  coverImageUrl: HERO_IMAGE,
  authorName: 'Daily Sports Life',
  clubName: 'കേരള കായിക വാർത്താ ഡെസ്ക്',
  blogCategory: 'boat-races',
  locale: 'ml',
  boatRaceTopic: 'chundan-2026',
  alternateSlug: 'nehru-trophy-2026-chundan-snake-boats-captains',
  audience: 'മലയാളി പ്രേക്ഷകർ',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'ബന്ധപ്പെട്ട ലേഖനങ്ങൾ',
  relatedPosts: [
    {
      slug: 'nehru-trophy-2026-chundan-snake-boats-captains',
      title: '72nd Nehru Trophy 2026: 22 Chundan Boats, Clubs & Captains (English)',
      blurb: 'ഇംഗ്ലീഷ് പതിപ്പ് — ക്ലബ് പട്ടികയും കാപ്റ്റൻ വിവരങ്ങളും.',
    },
    {
      slug: 'kerala-boat-race-nehru-trophy-ntbr-malayalam',
      title: 'കേരള വള്ളംകളി ഗൈഡ്: NTBR 2026 & നെഹ്‌റു ട്രോഫി ചരിത്രം',
      blurb: 'ചരിത്രവും സന്ദർശക ഗൈഡും — മലയാളം.',
    },
  ],
  referenceLinks: [
    {
      label: 'നെഹ്‌റു ട്രോഫി ഔദ്യോഗിക വെബ്സൈറ്റ്',
      url: 'https://nehrutrophy.nic.in/',
    },
    {
      label: 'ഓൺലൈൻ ടിക്കറ്റ് — NTBR 2026',
      url: 'https://nehrutrophy.nic.in/pages-en-IN/online_ticket.php',
    },
    {
      label: 'ട്രാക്ക് & ഹീറ്റ് ഷെഡ്യൂൾ',
      url: 'https://nehrutrophy.nic.in/pages-en-IN/track.php',
    },
    {
      label: 'The Hindu — 2026 തയ്യാറെടുപ്പ്',
      url: 'https://www.thehindu.com/news/national/kerala/boat-clubs-in-kerala-shift-into-high-gear-as-kuttanad-readies-for-prestigious-nehru-trophy-boat-race/article71271895.ece',
    },
    {
      label: 'ആലപ്പുഴ ജില്ല — നെഹ്‌റു ട്രോഫി',
      url: 'https://alappuzha.nic.in/en/nehru-trophy-boat-race/',
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'NTBR 2026 സംക്ഷിപ്തം',
      items: [
        { value: '22 ഓഗ 2026', label: '72-ാം നെഹ്‌റു ട്രോഫി' },
        { value: '22', label: 'ചുണ്ടൻ വള്ളങ്ങൾ' },
        { value: '71', label: 'ആകെ വള്ളങ്ങൾ' },
        { value: '1.4 കി.മീ', label: 'പ്രധാന ട്രാക്ക്' },
      ],
    },
    {
      type: 'panel',
      title: 'പുന്നമടയുടെ ആവേശം വീണ്ടും',
      paragraphs: [
        'കേരളത്തിന്റെ മഴക്കാലം വരുമ്പോൾ തിരക്കൊഴിഞ്ഞ കായലുകൾ മത്സരക്കളമായി മാറുന്നു. **വള്ളംകളി** — വെള്ളത്തിലെ കളി — കുട്ടനാടിന്റെ ഗ്രാമീണഹൃദയമാണ്. അതിൽ ഏറ്റവും വലിയ വേദി **നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ് (NTBR)**.',
        '**72-ാം നെഹ്‌റു ട്രോഫി വള്ളംകളി 2026 ഓഗസ്റ്റ് 22, ശനിയാഴ്ച**, **ആലപ്പുഴ ജില്ല, പുന്നമടക്കായലിൽ** നടക്കും. ഈ വർഷം വിവിധ വിഭാഗങ്ങളിൽ **71 വള്ളങ്ങൾ** രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്. പ്രധാന ആകർഷണമായ **ചുണ്ടൻ** (സ്നേക്ക് ബോട്ട്) വിഭാഗത്തിൽ മാത്രം **22 വള്ളങ്ങൾ** — കഴിഞ്ഞ വർഷത്തെക്കാൾ ഒന്ന് കൂടി.',
        'നൂറ് മുതൽ നൂറ്റി അമ്പതോളം വരികളുള്ള **ചുണ്ടൻ വള്ളം** ഒരു ഗ്രാമത്തിന്റെ അഭിമാനമാണ്. ട്രോഫി നേടിയ ഗ്രാമത്തിൽ ആഘോഷം ദിവസങ്ങളോളം നീണ്ടുനിൽക്കും. ലോകമെമ്പാടുള്ള മലയാളികൾ ടിവിയിലും സ്ട്രീമിങ്ങിലും ഈ ഒരു ശനിയാഴ്ചയ്ക്കായി കാത്തിരിക്കുന്നു.',
      ],
      chips: ['വള്ളംകളി', 'ചുണ്ടൻ', 'പുന്നമട', 'കുട്ടനാട്', 'ഓണം'],
    },
    {
      type: 'panel',
      title: 'ചുണ്ടൻ വള്ളം എന്താണ്?',
      paragraphs: [
        '**ചുണ്ടൻ വള്ളം** കേരളത്തിന്റെ പാരമ്പര്യ പോർവള്ളമാണ്. നീളം ഏകദേശം 100–138 അടി; മുൻഭാഗത്ത് പാമ്പിന്റെ തലക്ക്‌രി പോലുള്ള ഉയർന്ന കൊമ്പ്. **അഞ്ജിലി** മരത്തിൽ നിർമ്മിക്കുന്ന ഈ വള്ളത്തിൽ **100–150 പേര്** വരെ കൂടെ — വരികർ, അമരക്കാർ (തുനക്കർ), പാട്ടുകാരൻ, താളക്കാർ.',
        '1952-ൽ ജവഹർലാൽ നെഹ്‌റു ആലപ്പുഴ സന്ദർശിച്ചപ്പോൾ **നടുഭാഗം ചുണ്ടൻ** വിജയിച്ച യാദൃശ്ചിക മത്സരത്തിൽ നെഹ്‌റു തന്നെ വള്ളത്തിൽ കയറി യാത്ര ചെയ്തു. പിന്നീട് അദ്ദേഹം വെള്ളിപ്പാത്രത്തോടുകൂടിയ ട്രോഫി അനുദാനം ചെയ്തു — അതാണ് ഇന്നത്തെ **നെഹ്‌റു ട്രോഫി**.',
      ],
    },
    {
      type: 'imageGallery',
      title: 'പുന്നമടയുടെ ചിത്രങ്ങൾ',
      intro:
        'വള്ളംകളിയുടെ ആവേശം — യഥാർത്ഥ നെഹ്‌റു ട്രോഫി ചിത്രങ്ങൾ (Wikimedia Commons, CC BY-SA).',
      images: [
        {
          url: GALLERY_IMAGES.heats,
          alt: 'നെഹ്‌റു ട്രോഫി 2024 — ചുണ്ടൻ ഹീറ്റ്',
          caption: 'നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ് 2024, പുന്നമട — Varghesepunnamada / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.alleppey,
          alt: 'നെഹ്‌റു ട്രോഫി, ആലപ്പുഴ',
          caption: 'നെഹ്‌റു ട്രോഫി വള്ളംകളി, ആലപ്പുഴ — Wikimedia Commons.',
        },
        {
          url: GALLERY_IMAGES.aranmula,
          alt: 'കേരള വള്ളംകളി — ചുണ്ടൻ വള്ളങ്ങൾ',
          caption: 'കേരളത്തിലെ ചുണ്ടൻ വള്ളംകളി — Anoopkn / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.boats,
          alt: 'വെള്ളത്തിലെ വള്ളങ്ങൾ',
          caption: 'വരികളുടെ താളം — കുട്ടനാടിന്റെ ഹൃദയം.',
        },
      ],
    },
    {
      type: 'panel',
      title: '2026-ന്റെ പ്രത്യേകത: ആദ്യ വനിതാ കാപ്റ്റൻ',
      paragraphs: [
        '**നടുഭാഗം ചുണ്ടൻ** ഈ വർഷം ചരിത്രം രചിക്കുന്നു. **അനു ആൽബർട്ട് പുളിക്കട്ടിൽ** PBC പുന്നമട ടീമിന്റെ കാപ്റ്റനായി മത്സരിക്കുന്നു — നെഹ്‌റു ട്രോഫി ചുണ്ടൻ ഫൈനലിൽ **ആദ്യമായി ഒരു സ്ത്രീ കാപ്റ്റൻ** എന്ന നേട്ടം. (*The Hindu*, 2026)',
        'കുട്ടനാടിന്റെ പാരമ്പര്യ കായിക രംഗത്ത് ഇത് വലിയ ചുവപ്പുകല്ലാണ്. നടുഭാഗം 1952-ൽ നെഹ്‌റുവിനെ ആകർഷിച്ച ഐതിഹാസിക വള്ളം കൂടിയാണ് — ഈ വർഷം അത് പുതിയ അധ്യായത്തിലേക്ക്.',
      ],
      chips: ['നടുഭാഗം', 'അനു ആൽബർട്ട് പുളിക്കട്ടിൽ', 'ചരിത്രം', 'PBC പുന്നമട'],
    },
    {
      type: 'table',
      title: '22 ചുണ്ടൻ വള്ളങ്ങൾ, ക്ലബുകൾ, കാപ്റ്റൻമാർ',
      intro:
        '2026 രജിസ്ട്രേഷൻ + ലഭ്യമായ കാപ്റ്റൻ വിവരങ്ങൾ (2024–2026 ഔദ്യോഗിക/മാധ്യമ റിപ്പോർട്ടുകൾ). മത്സരത്തിന് മുൻപ് [nehrutrophy.nic.in](https://nehrutrophy.nic.in/)-ൽ അവസാന പട്ടിക സ്ഥിരീകരിക്കുക. «—» = ഇതുവരെ പൊതുവായി പ്രഖ്യാപിച്ചിട്ടില്ല.',
      headers: ['ക്ര.', 'ചുണ്ടൻ വള്ളം', 'ബോട്ട് ക്ലബ്', 'കാപ്റ്റൻ / ഹരിപ്പ് കാപ്റ്റൻ'],
      rows: [
        ['1', 'തലവടി ചുണ്ടൻ', 'കൈനകരി വില്ലേജ് ബോട്ട് ക്ലബ്', 'പത്മകുമാർ പുതেন്പരമ്പിൽ / രാഹുൽ പ്രകാശ്'],
        ['2', 'വീയപുരം ചുണ്ടൻ', 'UBC കൈനകരി', 'ബൈജു കുട്ടനാട് (2025 വിജയി ടീം)'],
        ['3', 'അരോമ ചുണ്ടൻ 1', 'അരോമ ബോട്ട് ക്ലബ്', '—'],
        ['4', 'മേൽപ്പാടം ചുണ്ടൻ', 'പള്ളാത്തുരുത്തി ബോട്ട് ക്ലബ്', '—'],
        ['5', 'ചെറുതന ചുണ്ടൻ', 'നാട്ടക്കം ബോട്ട് ക്ലബ്', 'മധു കുതപ്പൻ / കെ. ശാജി'],
        ['6', 'പുണ്യാളൻ നിരണം ചുണ്ടൻ', 'കുമരകം ടൗൺ ബോട്ട് ക്ലബ്', '—'],
        ['7', 'നടുഭാഗം ചുണ്ടൻ', 'PBC പുന്നമട / എൻസിഎഫ്സി', '**അനു ആൽബർട്ട് പുളിക്കട്ടിൽ** (2026)'],
        ['8', 'കരുവാറ്റ ചുണ്ടൻ', 'GLC ബോട്ട് ക്ലബ്, ചെറുതന', '—'],
        ['9', 'വെള്ളംകുളങ്ങര ചുണ്ടൻ', 'SH ബോട്ട് ക്ലബ്', '—'],
        ['10', 'ജവഹർ തായങ്കരി ചുണ്ടൻ', 'നാട്ടക്കം ഫാൻസ് ബോട്ട് ക്ലബ്', 'അശ്വന്ത് വി. പെരുമ്പിടക്കലം / ബെന്നി ബേബി'],
        ['11', 'സെന്റ് പയസ് X ചുണ്ടൻ', 'സെന്റ് പയസ് X ബോട്ട് ക്ലബ്', 'റെന്നി ഫിലിപ്പോസ് പുതেন്പരമ്പിൽ'],
        ['12', 'നിരണം ചുണ്ടൻ', 'നിരണം ബോട്ട് ക്ലബ്', 'കെ.ജി. അബ്രഹാം / ബിനു ശാജി'],
        ['13', 'ആയാപറമ്പ് വലിയ ദിവാൻജി ചുണ്ടൻ', 'വലിയ ദിവാൻജി ബോട്ട് ക്ലബ്', 'സണ്ണി ഇടിമണിക്കൽ / ബൈജപ്പൻ'],
        ['14', 'ആനാരി ചുണ്ടൻ', 'ആനാരി ബോട്ട് ക്ലബ്', '—'],
        ['15', 'ചമ്പക്കുളം ചുണ്ടൻ', 'ചമ്പക്കുളം ബോട്ട് ക്ലബ്', 'സന്തോഷ് ടി. കുരുവിള / ഹരിലാൽ കെ.വി.'],
        ['16', 'കാരിച്ചാൽ ചുണ്ടൻ', 'തെക്കേക്കര ബോട്ട് ക്ലബ്', 'അലൻ മൂന്നുടൈക്കൽ'],
        ['17', 'ആയാപറമ്പ് പാണ്ടി ചുണ്ടൻ', 'IBRA, കൊച്ചി', '—'],
        ['18', 'കരുവാറ്റ ശ്രീ വിനായകൻ ചുണ്ടൻ', 'KTBC ഫാൻസ് ക്ലബ്', '—'],
        ['19', 'ആർപ്പൂക്കര ചുണ്ടൻ', 'കുമരകം ഇമ്മാനുവൽ ബോട്ട് ക്ലബ്', '—'],
        ['20', 'ആലപ്പാട് ചുണ്ടൻ', 'സെന്റ് ജോൺസ് ബോട്ട് ക്ലബ്', '—'],
        ['21', 'പായിപ്പാടൻ 2 ചുണ്ടൻ', 'പള്ളാത്തുരുത്തി ബോട്ട് ക്ലബ്', 'മഹേഷ് കൃഷ്ണൻ നായർ / സാജൻ എ.ജെ.'],
        ['22', 'പാർത്ഥൻ ചുണ്ടൻ', 'ജൂനിയർ കൈനകരി ബോട്ട് ക്ലബ്', '—'],
      ],
    },
    {
      type: 'table',
      title: '2026-ൽ രജിസ്റ്റർ ചെയ്ത 22 ചുണ്ടൻ വള്ളങ്ങളും ക്ലബുകളും (സംക്ഷിപ്തം)',
      intro: 'ക്ലബ് പേരുകൾ മാത്രം — വേഗത്തിൽ നോക്കാൻ.',
      headers: ['ക്ര.', 'ചുണ്ടൻ വള്ളം', 'ബോട്ട് ക്ലബ്'],
      rows: [
        ['1', 'തലവടി ചുണ്ടൻ', 'കൈനകരി വില്ലേജ് ബോട്ട് ക്ലബ്'],
        ['2', 'വീയപുരം ചുണ്ടൻ', 'UBC കൈനകരി'],
        ['3', 'അരോമ ചുണ്ടൻ 1', 'അരോമ ബോട്ട് ക്ലബ്'],
        ['4', 'മേൽപ്പാടം ചുണ്ടൻ', 'പള്ളാത്തുരുത്തി ബോട്ട് ക്ലബ്'],
        ['5', 'ചെറുതന ചുണ്ടൻ', 'നാട്ടക്കം ബോട്ട് ക്ലബ്'],
        ['6', 'പുണ്യാളൻ നിരണം ചുണ്ടൻ', 'കുമരകം ടൗൺ ബോട്ട് ക്ലബ്'],
        ['7', 'നടുഭാഗം ചുണ്ടൻ', 'PBC പുന്നമട / നടുഭാഗം ചുണ്ടൻ ഫാൻസ് ക്ലബ്'],
        ['8', 'കരുവാറ്റ ചുണ്ടൻ', 'GLC ബോട്ട് ക്ലബ്, ചെറുതന'],
        ['9', 'വെള്ളംകുളങ്ങര ചുണ്ടൻ', 'SH ബോട്ട് ക്ലബ്'],
        ['10', 'ജവഹർ തായങ്കരി ചുണ്ടൻ', 'നാട്ടക്കം ഫാൻസ് ബോട്ട് ക്ലബ്'],
        ['11', 'സെന്റ് പയസ് X ചുണ്ടൻ', 'സെന്റ് പയസ് X ബോട്ട് ക്ലബ്'],
        ['12', 'നിരണം ചുണ്ടൻ', 'നിരണം ബോട്ട് ക്ലബ്'],
        ['13', 'ആയാപറമ്പ് വലിയ ദിവാൻജി ചുണ്ടൻ', 'വലിയ ദിവാൻജി ബോട്ട് ക്ലബ്'],
        ['14', 'ആനാരി ചുണ്ടൻ', 'ആനാരി ബോട്ട് ക്ലബ്'],
        ['15', 'ചമ്പക്കുളം ചുണ്ടൻ', 'ചമ്പക്കുളം ബോട്ട് ക്ലബ്'],
        ['16', 'കാരിച്ചാൽ ചുണ്ടൻ', 'തെക്കേക്കര ബോട്ട് ക്ലബ്'],
        ['17', 'ആയാപറമ്പ് പാണ്ടി ചുണ്ടൻ', 'IBRA, കൊച്ചി'],
        ['18', 'കരുവാറ്റ ശ്രീ വിനായകൻ ചുണ്ടൻ', 'KTBC ഫാൻസ് ക്ലബ്'],
        ['19', 'ആർപ്പൂക്കര ചുണ്ടൻ', 'കുമരകം ഇമ്മാനുവൽ ബോട്ട് ക്ലബ്'],
        ['20', 'ആലപ്പാട് ചുണ്ടൻ', 'സെന്റ് ജോൺസ് ബോട്ട് ക്ലബ്'],
        ['21', 'പായിപ്പാടൻ 2 ചുണ്ടൻ', 'പള്ളാത്തുരുത്തി ബോട്ട് ക്ലബ്'],
        ['22', 'പാർത്ഥൻ ചുണ്ടൻ', 'ജൂനിയർ കൈനകരി ബോട്ട് ക്ലബ്'],
      ],
    },
    {
      type: 'videoEmbed',
      title: 'മലയാളം വീഡിയോ — നെഹ്‌റു ട്രോഫി ഹൈലൈറ്റ്',
      intro:
        'കഴിഞ്ഞ വർഷങ്ങളിലെ ഏഷ്യനെറ്റ് ന്യൂസ് ഹൈലൈറ്റ്. 2026 ലൈവ് സ്ട്രീമിംഗ് മത്സര ദിവസം ഏഷ്യനെറ്റ്, മനോരമ, DD മലയാളം എന്നിവയിൽ ലഭ്യമാകും.',
      embeds: [
        {
          youtubeId: '0-rJfoKw9K0',
          title: 'Nehru Trophy Boat Race 2023 — Asianet News Malayalam',
          caption:
            '**ഏഷ്യനെറ്റ് ന്യൂസ്:** ചുണ്ടൻ ഫൈനലിന്റെ അവസാന നിമിഷങ്ങൾ — വരികളുടെ താളവും ആവേശവും.',
        },
      ],
    },
    {
      type: 'videoList',
      title: 'ലൈവ് & ഹൈലൈറ്റ് — YouTube ചാനലുകൾ',
      intro: 'മത്സര ദിവസം ഈ ചാനലുകളിൽ «നെഹ്‌റു ട്രോഫി വള്ളംകളി» തിരയുക.',
      videos: [
        {
          title: 'Asianet News Live',
          channel: 'ഏഷ്യനെറ്റ് ന്യൂസ്',
          description: 'കേരളത്തിലെ പ്രധാന വാർത്താ ചാനൽ — NTBR ലൈവ് കവറേജ് പതിവായി.',
          url: 'https://www.youtube.com/@asianetnews',
        },
        {
          title: 'Manorama News',
          channel: 'മനോരമ ന്യൂസ്',
          description: '71-ാം നെഹ്‌റു ട്രോഫി ഫൈനൽ ഹൈലൈറ്റുകൾയും ലൈവ് സ്ട്രീമും.',
          url: 'https://www.youtube.com/@manoramanews',
        },
        {
          title: 'MediaOne Live',
          channel: 'മീഡിയവൺ',
          description: 'മലയാളം വാർത്താ കവറേജ് — വള്ളംകളി സീസൺ.',
          url: 'https://www.youtube.com/@MediaOneTVLive',
        },
        {
          title: 'DD Malayalam',
          channel: 'ദൂരദർശൻ മലയാളം',
          description: 'പ്രഭുത്വ ചാനലിന്റെ NTBR പ്രക്ഷേപണം (വർഷം അനുസരിച്ച്).',
          url: 'https://www.youtube.com/@DoordarshanMalayalam',
        },
      ],
    },
    {
      type: 'panel',
      title: '2025 ഫൈനൽ ഫലം — ഈ വർഷത്തേക്കുള്ള സൂചന',
      paragraphs: [
        '71-ാം നെഹ്‌റു ട്രോഫി (2025) **വീയപുരം ചുണ്ടൻ** (കൈനകരി വില്ലേജ് ബോട്ട് ക്ലബ്) വിജയിച്ചു — സമയം **4:21.084**. ഫോട്ടോ ഫിനിഷിൽ **നടുഭാഗം** രണ്ടാം സ്ഥാനം, **മേൽപ്പാടം** മൂന്നാം, **നിരണം** നാലാം.',
        'ഈ പട്ടികയിൽ **വീയപുരം**, **നടുഭാഗം**, **കാരിച്ചാൽ**, **ചമ്പക്കുളം**, **നിരണം** തുടങ്ങിയ പഴയ നക്ഷത്രങ്ങളും **അരോമ**, **പാർത്ഥൻ** പോലുള്ള പുതിയ മുഖങ്ങളും ഉണ്ട്.',
      ],
      list: [
        '**നടുഭാഗം ചുണ്ടൻ** — 1952-ൽ നെഹ്‌റുവിനെ ആകർഷിച്ച ഐതിഹാസിക വള്ളം; 2026-ൽ അനു ആൽബർട്ട് കാപ്റ്റൻ.',
        '**കാരിച്ചാൽ ചുണ്ടൻ** — കുട്ടനാടിന്റെ ഏറ്റവും ജനപ്രിയ പേരുകളിൽ ഒന്ന്; 2024 വിജയി.',
        '**ചമ്പക്കുളം ചുണ്ടൻ** — ചമ്പക്കുളം മൂലം വള്ളംകളിയുടെ പാരമ്പര്യം.',
        '**പാർത്ഥൻ ചുണ്ടൻ** — ജൂനിയർ കൈനകരി ക്ലബ്ബിന്റെ പുതിയ പങ്കാളിത്തം.',
      ],
    },
    {
      type: 'table',
      title: 'മറ്റ് വിഭാഗങ്ങളിലെ വള്ളങ്ങൾ (2026)',
      intro:
        'ചുണ്ടൻ ഫൈനലിന് പുറകിൽ ചുരുളൻ, ഇരുട്ടുകുത്തി, വെപ്പ്, തെക്കനോടി തുടങ്ങിയ വിഭാഗങ്ങളിലും മത്സരം നടക്കും.',
      headers: ['വിഭാഗം', 'വള്ളങ്ങളുടെ എണ്ണം', 'കുറിപ്പ്'],
      rows: [
        ['ചുരുളൻ', '2', 'ചെറിയ വള്ളം; പ്രാദേശിക മത്സരം'],
        ['ഇരുട്ടുകുത്തി A', '3', 'ഇരുട്ടുകുത്തി വിഭാഗം — A ഗ്രേഡ്'],
        ['ഇരുട്ടുകുത്തി B', '16', 'ഏറ്റവും വലിയ ഉപവിഭാഗങ്ങളിൽ ഒന്ന്'],
        ['ഇരുട്ടുകുത്തി C', '14', 'ഹീറ്റുകളും ലൂസേഴ്സ് റൗണ്ടുകളും'],
        ['വെപ്പ് A', '5', 'പാരമ്പര്യ വെപ്പ് വള്ളം'],
        ['വെപ്പ് B', '4', 'വെപ്പ് വിഭാഗം B'],
        ['തെക്കനോടി തറ', '1', 'തെക്കനോടി വിഭാഗം'],
        ['തെക്കനോടി കെട്ട്', '4', 'തെക്കനോടി കെട്ട് വിഭാഗം'],
      ],
    },
    {
      type: 'panel',
      title: 'മത്സര ദിവസം — എന്ത് പ്രതീക്ഷിക്കാം?',
      orderedList: [
        '**തീയതി:** 2026 ഓഗസ്റ്റ് 22 (ശനിയാഴ്ച)',
        '**സ്ഥലം:** പുന്നമടക്കായല്‍, ആലപ്പുഴ',
        '**ദൂരം:** ചുണ്ടൻ ഫൈനൽ ട്രാക്ക് ഏകദേശം 1.4 കിലോമീറ്റർ',
        '**സമ്മാനം:** വിജയി ടീമിന് സർക്കാർ പ്രഖ്യാപിച്ച ഉയർന്ന സമ്മാനത്തുക (₹25 ലക്ഷം വരെ — വർഷം അനുസരിച്ച് മാറാം)',
        '**ടിക്കറ്റ്:** [nehrutrophy.nic.in](https://nehrutrophy.nic.in/pages-en-IN/online_ticket.php) വഴി ഓൺലൈൻ ബുക്കിംഗ്',
        '**ട്രാഫിക്:** രണ്ട് ലക്ഷത്തിലധികം പ്രേക്ഷകർ — നേരത്തേ എത്തുക',
      ],
      paragraphs: [
        'പ്രഭാതത്തിൽ പ്രദർശന വള്ളങ്ങൾ, ചെണ്ടകളും തുലാസരങ്ങളും — ഉച്ചയ്ക്ക് ശേഷം ഹീറ്റുകൾ. വൈകുന്നേരം **ചുണ്ടൻ ഫൈനൽ** — കായല മുഴുവൻ വരികൾ ഒരുമിച്ച് അടിക്കുന്ന ശബ്ദം, **വഞ്ചിപ്പാട്ട്**, ചെണ്ട താളം — NTBR-ന്റെ സാർവ്വകാലിക ചിത്രം.',
        '2026-ൽ **ചാമ്പ്യൻസ് ബോട്ട് ലീഗ് (CBL)** സീസണും തുടങ്ങുന്നു; NTBR ആദ്യത്തെ വലിയ വേദിയാണ്.',
      ],
    },
    {
      type: 'panel',
      title: 'പ്രേക്ഷകർക്കുള്ള നുറുങ്ങുകൾ',
      list: [
        'ആലപ്പുഴ ഹോട്ടലുകളും ഹൗസ്ബോട്ടുകളും വേഗം നിറയുന്നു — മുൻകൂട്ടി ബുക്ക് ചെയ്യുക.',
        'ഔദ്യോഗിക ടിക്കറ്റ് മാത്രം വിശ്വസിക്കുക; കരിഞ്ഞാപ്പം വിലക്കൾക്ക് വിധേയമാണ്.',
        'സൺസ്ക്രീൻ, മഴക്കുട, തണ്ണിച്ച വെള്ളം കൊണ്ടുപോകുക.',
        'വള്ളത്തിനും തീരത്തിനും മര്യാദ പാലിക്കുക — ഇത് ജീവിത സംസ്കാരമാണ്, ടൂറിസം മാത്രമല്ല.',
        'വിദേശത്ത് നിന്ന് കാണുന്നവർ: മലയാളം ടിവി/സ്ട്രീമിംഗ് കവറേജ് പരിശോധിക്കുക; സമയ വ്യത്യാസം ഓർക്കുക.',
      ],
      callout: {
        text: 'ഔദ്യോഗിക ടിക്കറ്റ് ബുക്ക് ചെയ്യുക →',
        url: 'https://nehrutrophy.nic.in/pages-en-IN/online_ticket.php',
      },
    },
    {
      type: 'panel',
      title: 'ചുരുക്കത്തിൽ',
      paragraphs: [
        '**72-ാം നെഹ്‌റു ട്രോഫി വള്ളംകളി** കേരളത്തിന്റെ വെള്ളത്തിലെ ഏറ്റവും വലിയ ഉത്സവമാണ്. 2026-ൽ **22 ചുണ്ടൻ വള്ളങ്ങൾ**, **71 വള്ളങ്ങൾ** ആകെ — കുട്ടനാടിന്റെ ഗ്രാമ ക്ലബുകൾ പുന്നമടയിൽ ഒത്തുചേരുന്നു.',
        'നിങ്ങൾ ആലപ്പുഴയിലാണോ, അമേരിക്കയിലാണോ, യൂറോപ്പിലാണോ — ഈ ശനിയാഴ്ച കായലയുടെ താളം എല്ലാവരുടെയും ഹൃദയത്തിലുണ്ടാകും. **നല്ല വരികൾ, നല്ല താളം, നല്ല മത്സരം!**',
      ],
      chips: ['നെഹ്‌റു ട്രോഫി', 'ചുണ്ടൻ', 'വള്ളംകളി', 'ആലപ്പുഴ', '2026'],
    },
  ],
};
